import { render, staticRenderFns } from "./contactface.vue?vue&type=template&id=f0967088&"
import script from "./contactface.vue?vue&type=script&lang=js&"
export * from "./contactface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports